module.exports = __webpack_public_path__ + "e9e265fee64b37c43860a8d820cc9cfd.png";